import { Dumbbell } from 'lucide-react'

export default function ExerciseImage({ 
    exercises, 
    exercise, 
    className = 'w-12 h-12',
    onClick = () => {}
}) {

    const foundExercise = exercises?.find((item) => item.id === exercise?.id)

    if (exercises?.length === 0 || !foundExercise) {
        return (
            <div className='w-full h-full bg-gray-200 rounded-lg flex items-center justify-center'>
                <Dumbbell className='w-8 h-8 text-gray-500' />
            </div>
        )
    }
    
    return (
        <div 
            className={`
                ${className}
                bg-gray-200 rounded-lg overflow-hidden flex-shrink-0 cursor-pointer
            `}
            onClick={onClick}
        >
            <img 
                src={foundExercise.imageUrl} 
                alt={exercise.name}
                className="w-full h-full object-cover"
            />
        </div>
    )
}
